export default __webpack_public_path__ + "static/media/NLPC.b4c000f6.png";